<template>
  <ToggleButton
    :value="field.filter.value == 1"
    @input="$emit('input', $event == true ? 1 : 0)"
    type-bold="true"
    class="mb-0"
  ></ToggleButton>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  methods: {},
}
</script>
